import { createActionCreator, createReducer } from 'deox';

export const headerMenuItems = {
  home: 'Home',
  promotions: 'Promotions',
  'program-schedule': 'Program Schedule',
  'other-pages': 'Other Pages',
  subscriber: 'Subscribers',
  coupon: 'Coupon',
};

export type HeaderTabId = keyof typeof headerMenuItems;

interface State {
  readonly tabId?: HeaderTabId;
}

const initialState: State = {
  tabId: undefined,
};

const setTabId = createActionCreator(
  'ADMIN/SET_TAB_ID',
  (resolve) => (tabId: HeaderTabId) => resolve(tabId)
);

export const adminActions = {
  setTabId,
};

export default createReducer(initialState, (handleAction) => [
  handleAction(setTabId, (state, { payload }) => ({
    ...state,
    tabId: payload,
  })),
]);

interface SelectorT {
  admin: State;
}
export const adminSelectors = {
  getTabId: ({ admin: state }: SelectorT) => state.tabId,
};
